import React from 'react';
import Text from 'components/Text';

const typographyMap = {
    h1: ['Primary/24_110_510_-3', null, null, null, 'Primary/30_100_510_-5'],
    h2: ['Primary/15_120_510_-1', null, null, null, 'Primary/20_120_510_-3'],
    h3: ['Primary/Mobile/13_100_510_-1', null, null, null, 'Primary/20_120_510_-3'],
    h4: ['Primary/Mobile/13_100_510_-1', null, null, null, 'Primary/20_120_510_-3'],
    h5: ['Primary/Mobile/13_100_510_-1', null, null, null, 'Primary/20_120_510_-3'],
    h6: ['Primary/Mobile/13_100_510_-1', null, null, null, 'Primary/20_120_510_-3'],
};

interface HeadingProps {
    type: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
    children: React.ReactNode;
}

const Heading: React.FC<HeadingProps> = ({ type, children }) => (
    <Text $as={type} typography={typographyMap[type]} mb="16px">
        {children}
    </Text>
);

export default Heading;
